import axios from 'axios';
import { ValidationError, ServerError, UnauthorizedError } from './Exception';
//const API_URL = 'http://192.168.1.14/appv2/';
const TIMEOUT_LIMIT = 32000;
const PLATFORM = 'WEB';
const API_VERSION = '2.0.1';
const requestHandler = async (config) => {
    if (config.headers) {
        config.headers['App-Ver'] = `MVMWEB; ${PLATFORM};`;
        config.headers['Api-Version'] = API_VERSION;
    }
    return config;
};
const successHandler = (response) => {
    if (response.data.success) {
        return response.data;
    }
    const errorMessage = response.data.error_msg !== null ? response.data.error_msg : `Something went wrong`;
    const errors = response.data.errors !== null ? response.data.errors : [];
    if (errorMessage === undefined) {
        console.error('Response payload', response);
        throw new Error(`Unable to find valid error message when executing "successHandler" please check the browser console.`);
    }
    throw new ValidationError(errorMessage, errors);
};
const errorHandler = async (error) => {
    let statusCode = error.response?.status;
    // 524 Cloudflare
    switch (statusCode) {
        case 401:
            throw new UnauthorizedError(`You have signed in to another location or lost access, please log in again.`);
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
        case 506:
        case 507:
        case 508:
        case 510:
        case 511:
            throw new ServerError(error.message);
        default:
            return Promise.reject(error);
    }
};
export const apiClient = () => {
    const client = axios.create({
        baseURL: '',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'App-Ver': `MVMWEB; ${PLATFORM};`,
            'Api-Version': API_VERSION,
        },
        timeout: TIMEOUT_LIMIT,
    });
    client.interceptors.request.use(requestHandler);
    // @ts-ignore
    client.interceptors.response.use(successHandler, errorHandler);
    return client;
};
